import { apiHeliosClient } from 'src/data/api/apiHeliosClient';
import {
  ListReasonsCommand,
  ListReasonsCommandInput,
  CreateReasonCommand,
  CreateReasonCommandInput,
  UpdateReasonCommand,
  UpdateReasonCommandInput,
  DeactivateReasonCommand,
  DeactivateReasonCommandInput,
} from '@amzn/gbsa-helios-typescript-client';

export const reasonService = {
  list: (data: ListReasonsCommandInput) => {
    return apiHeliosClient.send(new ListReasonsCommand(data));
  },
  create: (data: CreateReasonCommandInput) => {
    return apiHeliosClient.send(new CreateReasonCommand(data));
  },
  update: (data: UpdateReasonCommandInput) => {
    return apiHeliosClient.send(new UpdateReasonCommand(data));
  },
  deactivate: (data: DeactivateReasonCommandInput) => {
    return apiHeliosClient.send(new DeactivateReasonCommand(data));
  },
};
